import { ENQUIRY_MODE_KEY } from 'configs/localData/constant';
import { createSelector } from 'reselect';

const getRawEnquiryMode = (state) => state.appSettings[ENQUIRY_MODE_KEY];

export const getEnquiryMode = createSelector(
  [getRawEnquiryMode],
  (data) => data,
);
